import { render, staticRenderFns } from "./PartsDetails.vue?vue&type=template&id=56baae97&scoped=true&"
import script from "./PartsDetails.vue?vue&type=script&lang=js&"
export * from "./PartsDetails.vue?vue&type=script&lang=js&"
import style0 from "./PartsDetails.vue?vue&type=style&index=0&id=56baae97&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56baae97",
  null
  
)

export default component.exports